import { DashboardMain } from "./v2";

const Dashboard = () => {
  return <DashboardMain />;
};

export default Dashboard;
